import { atom } from "jotai";
import { StudyParticipantConfig } from "../types/IStudyParticipantConfig";

export const studyParticipantConfigAtom = atom<StudyParticipantConfig | null>(
  null,
);
